// Check if passwordlessLoginTranslations exists
if (typeof passwordlessLoginTranslations === 'undefined') {
  console.error('passwordlessLoginTranslations is not defined');
  throw new Error('Missing required translations object: passwordlessLoginTranslations');
}
const translation = passwordlessLoginTranslations;

/**
 * Adds the registration block to the login section.
 */
function addRegisterContainer() {
  const shopifyRoot = Shopify?.routes?.root || '/';
  const loginSection = document.querySelector('.rc-login');

  if (!loginSection) return;

  const registerContainer = createElementWithClass('div', 'customer-footer');

  const [loginParagraph, loginLink] = createLoginSection(shopifyRoot, translation);
  const [registerParagraph, registerLink] = createRegisterSection(shopifyRoot, translation);

  const divider = createElementWithClass('span', 'divider');

  appendChildren(registerContainer, loginParagraph, loginLink, divider, registerParagraph, registerLink);

  loginSection.appendChild(registerContainer);
}

/**
 * Creates the login section block.
 * @param {string} shopifyRoot
 * @param {Object} translation
 * @returns {HTMLElement[]}
 */
function createLoginSection(shopifyRoot, translation) {
  const loginParagraph = createParagraph(translation.login_with_password_message);
  const loginLink = createLink(`${shopifyRoot}account/login?use_password=true`, translation.login_link_text, 'register__link');
  return [loginParagraph, loginLink];
}

/**
 * Creates the registration section block.
 * @param {string} shopifyRoot
 * @param {Object} translation
 * @returns {HTMLElement[]}
 */
function createRegisterSection(shopifyRoot, translation) {
  const registerParagraph = createParagraph(translation.register_message);
  const registerLink = createLink(`${shopifyRoot}account/register`, translation.register_link_text, 'register__link');
  return [registerParagraph, registerLink];
}

/**
 * Creates an element with a specified class.
 * @param {string} tag
 * @param {string} className
 * @returns {HTMLElement}
 */
function createElementWithClass(tag, className) {
  const element = document.createElement(tag);
  if (className) element.className = className;
  return element;
}

/**
 * Appends child elements to a parent element.
 * @param {HTMLElement} parent
 * @param {...HTMLElement} children
 */
function appendChildren(parent, ...children) {
  children.forEach((child) => parent.appendChild(child));
}

/**
 * Creates a paragraph element with text content.
 * @param {string} text
 * @returns {HTMLParagraphElement}
 */
function createParagraph(text) {
  const paragraph = document.createElement('p');
  paragraph.innerHTML = text;
  return paragraph;
}

/**
 * Creates a link element with text content.
 * @param {string} href
 * @param {string} text
 * @param {string} linkClass
 * @param {string} spanClass
 * @returns {HTMLAnchorElement}
 */

function createLink(href, text, linkClass, spanClass) {
  const link = createElementWithClass('a', linkClass);
  link.href = href;

  const span = createElementWithClass('span', spanClass);
  span.innerHTML = text;

  link.appendChild(span);
  return link;
}

addRegisterContainer();
